import React from 'react';
import PropTypes from 'prop-types';

const RecordPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M5 6C3.343 6 2 7.343 2 9V23C2 24.657 3.343 26.001 5 26.001H19C20.656 26.001 22 24.657 22 23V9C22 7.343 20.656 6 19 6H5ZM30.882 7.629L24.255 11.357C24.098 11.445 24 11.612 24 11.792V20.208C24 20.388 24.098 20.555 24.255 20.643L30.882 24.372C30.995 24.435 31.121 24.468 31.25 24.468C31.664 24.468 32 24.132 32 23.717V8.282C32 8.154 31.967 8.027 31.904 7.915C31.766 7.67 31.511 7.533 31.249 7.533C31.124 7.533 30.998 7.563 30.882 7.629Z"
    />
  );
};

RecordPath.propTypes = {
  fill: PropTypes.string,
};

export default RecordPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/record.jsx